import React from "react";
import { Link } from "../i18n/router";
import { Sparkles } from "lucide-react";

/**
 * EUNOIA-styled 404. Calm, on-brand, points the visitor back to the two
 * most likely destinations (home + events) instead of leaving them stuck on
 * a blank screen after a mistyped or expired link.
 */
const NotFoundPage = () => {
  return (
    <div
      className="min-h-[70vh] flex items-center justify-center px-6 py-20"
      data-testid="not-found-page"
    >
      <div className="eunoia-surface p-10 sm:p-14 max-w-lg w-full text-center">
        <div
          className="inline-flex items-center justify-center h-14 w-14 rounded-full mb-8"
          style={{ backgroundColor: "var(--eunoia-accent-whisper)" }}
        >
          <Sparkles
            className="h-7 w-7"
            style={{ color: "var(--eunoia-accent)" }}
          />
        </div>

        <div
          className="eunoia-caption mb-3"
          style={{ color: "var(--eunoia-accent)", letterSpacing: "0.2em" }}
          data-testid="not-found-code"
        >
          404
        </div>

        <h1 className="eunoia-title-medium mb-5">
          Кажется, эта тропа заросла
        </h1>

        <p className="eunoia-body mb-10 max-w-md mx-auto">
          Страница, которую вы искали, не найдена. Возможно, ссылка
          устарела — мягко вернёмся в пространство EUNOIA.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="eunoia-btn-primary"
            data-testid="not-found-home-btn"
          >
            На главную
          </Link>
          <Link
            to="/events"
            className="eunoia-btn-secondary"
            data-testid="not-found-events-btn"
          >
            К событиям
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
